import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Card,
  CardMedia,
  Grid,
  IconButton,
  LinearProgress,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CustomAutocomplete from "../../components/library/CustomAutocomplete";
import CustomDatePicker from "../../components/library/CustomDatePicker";
import CustomSearchBar from "../../components/library/CustomSearchBar";
import CustomSelect from "../../components/library/CustomSelect";
import CustomTable from "../../components/library/CustomTable/Index";
import CutomConfirmationModel from "../../components/library/CutomConfirmationModel";
import Slider from "../../components/library/ImageSlider/Slider";
import PopupWithEmptyContent from "../../components/library/PopupWithEmptyContent";
import Loader from "../../components/loader";
import ImageNotFound from "../../assets/missino-image-available.jpg";
import {
  deleteInspection,
  getInspectionDetails,
  getInspectionDetailsByDate,
  getLocations,
  getVisitBy,
} from "./api";

const ImageWithLoader = ({ src, alt, index, onClick }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true); // Set loading to true whenever src changes
  }, [src]);

  const handleImageLoad = () => {
    setLoading(false);
  };

  return (
    <Card
      sx={{
        width: 100,
        height: loading ? 200 : "auto",
        maxHeight: 100,
        position: "relative",
      }}
    >
      {loading && src !== "https://s3.amazonaws.com/null" && (
        <Box sx={{ height: "100%", padding: "50% 10%" }}>
          <LinearProgress sx={{ height: 5 }} />
        </Box>
      )}
      {src !== "https://s3.amazonaws.com/null" ? (
        <Button onClick={onClick} sx={{ padding: 0 }}>
          <CardMedia
            component="img"
            src={src}
            alt={alt}
            onLoad={handleImageLoad}
            style={{ display: loading ? "none" : "block" }}
          />
        </Button>
      ) : (
        <CardMedia
          component="img"
          src={ImageNotFound}
          alt={alt}
          onLoad={handleImageLoad}
          style={{ display: loading ? "none" : "block" }}
        />
      )}
    </Card>
  );
};

export default function InspectionDetails() {
  const [rows, setRows] = useState();
  const [filteredRows, setFilteredRows] = useState([]);
  const [openEmptyPopup, setOpenEmptyPopup] = useState(false);
  const [sliderImageData, setSliderImageData] = useState([]);
  const [customSelectValue, setcustomSelectValue] = useState("Location");
  const [autocmpleteValue, setAutocompleteValue] = useState(null);
  const [openConfirmationModel, setOpenConfirmationModel] = useState(false);
  const [locations, setLocations] = useState([]);
  const [visitBy, setvisitBy] = useState([]);
  const [visitDate, setvisitDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [loading, setloading] = useState(false);
  const [isDelete, setisDelete] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState({});
  const [isSearch, setIsSearch] = useState(0);
  const [searchVal, setSearchVal] = useState("");
  const [pagination, setpagination] = useState(0);

  const [poolId, setPoolId] = useState({
    label: "",
    value: -1,
    type: "Location",
  });
  const [userId, setUserId] = useState({
    label: "",
    value: -1,
    type: "VisitBy",
  });

  const columns = [
    "Pool Name",
    "Picture",
    "Chlorine",
    "pH",
    "Lifeguard in uniform",
    "Lifeguard sitting in proper location",
    "Visited By",
    "Visited Date",
    "Actions",
  ];

  const imageSliderPopup = (index, data) => {
    let allImagesData = data?.slice(index);
    let allUrl = allImagesData?.map((item) => item.picUrl);
    setSliderImageData(allUrl);
    setOpenEmptyPopup(true);
  };

  const loadinspectionDetails = async (isVisitDate = false) => {
    setSearchVal("");
    setpagination(0);
    let response;
    if (isVisitDate) {
      response = await getInspectionDetailsByDate(setloading, visitDate);
    } else {
      response = await getInspectionDetails(setloading, poolId, userId);
    }

    let data = response?.aaData?.map((item, index) => {
      return {
        name: item?.poolName,
        image: (
          <ImageWithLoader
            src={item?.picUrl}
            alt="Inspection Image"
            index={index}
            onClick={() => imageSliderPopup(index, response?.aaData)}
          />
        ),
        clorine: item?.Chlorine,
        ph: item?.pH,
        lifeunoform: item["Lifeguard in uniform?"],
        lifeguard: item["Lifeguard sitting in proper location?"],
        visitedby: item?.visitedBy,
        visiteddate: item?.visitDate
          ? dayjs(item?.visitDate).format("MM/DD/YYYY HH:mm A")
          : "",
        actions: (
          <Tooltip title="Delete" arrow>
            <IconButton onClick={() => setOpenConfirmationModel(true)}>
              <DeleteIcon color="error" />
            </IconButton>
          </Tooltip>
        ),
        id: item?.visitId,
      };
    });
    setRows(data);
    setFilteredRows(data);
  };

  // get location for dropdown
  const fetchlocations = async () => {
    let response = await getLocations(setloading);
    let data = await response?.data?.map((item) => {
      return {
        label: item?.poolName,
        value: item?.poolId,
        type: "Location",
      };
    });
    setLocations(data);
    if (data && data?.length > 0) setPoolId(data[0]);
  };

  // get employees
  const fetchVisitBy = async () => {
    let response = await getVisitBy(setloading);
    let data = await response?.data?.map((item) => {
      return {
        label: `${item?.firstName} ${item?.lastName}`,
        value: item?.userId,
        type: "VisitBy",
      };
    });
    setvisitBy(data);
  };

  const deleteData = async () => {
    // Asynchronous operations
    let response = await deleteInspection(setloading, selectedRowData?.id);
    toast.success(response.message || "Visit deleted successfully!");
    await loadinspectionDetails();
  };

  // get data as per the selected date
  useEffect(() => {
    loadinspectionDetails(true);
  }, [visitDate]);

  // on change of dropdowns get inspections details
  useEffect(() => {
    loadinspectionDetails();
  }, [poolId, userId]);

  // initial load data for dropdowns
  useEffect(() => {
    fetchlocations();
    fetchVisitBy();
  }, []);

  // delete confirmation
  useEffect(() => {
    if (isDelete) {
      setOpenConfirmationModel(false);
      setisDelete(false);
      if (selectedRowData?.id) {
        try {
          deleteData();
        } catch (error) {
          toast.error("Something went wrong!");
        }
      }
    }
  }, [isDelete]);

  // on change of dropdowns get inspections details
  useEffect(() => {
    if (autocmpleteValue?.type === "Location") {
      setPoolId(autocmpleteValue);
    } else if (autocmpleteValue?.type === "VisitBy") {
      setUserId(autocmpleteValue);
    }
  }, [autocmpleteValue]);

  // on change of filter dropdown
  useEffect(() => {
    if (customSelectValue && customSelectValue === "Location") {
      setUserId({
        label: "",
        value: -1,
        type: "VisitBy",
      });
    } else if (customSelectValue && customSelectValue === "Visited Date") {
      loadinspectionDetails(true);
    } else if (customSelectValue && customSelectValue === "Visited By") {
      setUserId({
        label: visitBy && visitBy.length > 0 ? visitBy[0]?.label : "",
        value: visitBy && visitBy.length > 0 ? visitBy[0]?.value : "",
        type: "VisitBy",
      });
    }
  }, [customSelectValue]);

  return (
    <div>
      {/* Application loader */}
      {loading && <Loader />}

      <PopupWithEmptyContent
        open={openEmptyPopup}
        setOpen={setOpenEmptyPopup}
        content={<Slider images={sliderImageData} />}
      />

      <CutomConfirmationModel
        open={openConfirmationModel}
        setOpen={setOpenConfirmationModel}
        title={"Delete Confirmation"}
        messege={
          <Typography>
            Are you sure you want to delete
            <span style={{ color: "red" }}> {selectedRowData?.name} </span>?
          </Typography>
        }
        setisAction={setisDelete}
      />

      <Grid
        container
        justifyContent={"space-between"}
        alignItems={"center"}
        gap={2}
      >
        <Grid item md={3} xs={12} sm={12}>
          <CustomSelect
            setpagination={setpagination}
            filterValue={customSelectValue}
            setFilterValue={setcustomSelectValue}
            title={"Filter by"}
            options={[
              { label: "Location", value: "Location" },
              { label: "Visited Date", value: "Visited Date" },
              { label: "Visited By", value: "Visited By" },
            ]}
          />
        </Grid>

        {customSelectValue == "Location" && (
          <Grid item md={3} xs={12} sm={12}>
            <CustomAutocomplete
              setpagination={setpagination}
              title={"Location"}
              autocmpleteValue={poolId}
              setAutocompleteValue={setAutocompleteValue}
              options={locations}
            />
          </Grid>
        )}

        {customSelectValue == "Visited By" && (
          <Grid item md={3} xs={12} sm={12}>
            <CustomAutocomplete
              setpagination={setpagination}
              title={"Visited By"}
              autocmpleteValue={userId}
              setAutocompleteValue={setAutocompleteValue}
              options={visitBy}
            />
          </Grid>
        )}

        {customSelectValue == "Visited Date" && (
          <Grid item md={3} xs={12} sm={12}>
            <CustomDatePicker
              setpagination={setpagination}
              label={"Visited Date"}
              visitDate={visitDate}
              setvisitDate={setvisitDate}
            />
          </Grid>
        )}

        <Grid item md={3} xs={12} sm={12}>
          <CustomSearchBar
            rows={rows}
            setFilteredRows={setFilteredRows}
            setpagination={setpagination}
            setIsSearch={setIsSearch}
            searchVal={searchVal}
            setSearchVal={setSearchVal}
          />
        </Grid>

        <Grid item md={1.6} xs={12} sm={12}>
          <Button
            size={"large"}
            variant={"contained"}
            sx={{ textTransform: "capitalize", padding: "16.5px 14px;" }}
            color="secondary"
            fullWidth
            onClick={() =>
              loadinspectionDetails(
                customSelectValue == "Visited Date" ? true : false
              )
            }
          >
            Refresh
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ mt: 2 }}>
        <CustomTable
          pagination={pagination}
          rows={filteredRows}
          columns={columns}
          setSelectedRowData={setSelectedRowData}
          isSearch={isSearch}
        />
      </Box>
    </div>
  );
}
